import {
  Box,
  Button,
  Paper,
  Typography,
  Stack,
} from "@mui/material";
import portalLogo from "../assets/eko.png";
import { useAppTranslation } from "../hooks/useAppTranslation";

type LoginPageProps = {
  onLogin: () => void;
};

export default function LoginPage({ onLogin }: LoginPageProps) {
  const { t } = useAppTranslation("common");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #274156 0%, #1c6e8c 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtelne światło akcentowe */}
      <Box
        sx={{
          position: "absolute",
          width: 450,
          height: 450,
          bgcolor: "rgba(230,57,70,0.12)",
          borderRadius: "50%",
          top: -120,
          right: -120,
          filter: "blur(100px)",
        }}
      />

      <Paper
        elevation={10}
        sx={{
          px: 6,
          py: 7,
          width: 460,
          borderRadius: 4,
          textAlign: "center",
          backgroundColor: "rgba(255,255,255,0.96)",
        }}
      >
        <Stack spacing={5} alignItems="center">
          
          {/* LOGO z większą przestrzenią */}
          <Box
            component="img"
            src={portalLogo}
            alt="Logo"
            sx={{
              height: 95,
              objectFit: "contain",
              filter: "drop-shadow(0 6px 16px rgba(0,0,0,0.25))",
              mb: 2,
            }}
          />

          {/* Nazwa + opis */}
          <Box>
            <Typography
              variant="h4"
              fontWeight={600}
              sx={{ color: "#274156", letterSpacing: 0.5 }}
            >
              Portal EKO
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 1.5, color: "text.secondary" }}
            >
              {t("Bezpieczny dostęp do obiegu dokumentów")}
            </Typography>
          </Box>

          {/* CTA */}
          <Button
            fullWidth
            size="large"
            onClick={onLogin}
            variant="contained"
            sx={{
              py: 1.6,
              fontWeight: 600,
              fontSize: 16,
              textTransform: "none",
              borderRadius: 2,
              backgroundColor: "#e63946",
              boxShadow: "0 8px 20px rgba(230,57,70,0.35)",
              "&:hover": {
                backgroundColor: "#d62839",
                boxShadow: "0 10px 24px rgba(230,57,70,0.45)",
              },
            }}
          >
            {t("Zaloguj się")}
          </Button>

          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Portal EKO
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}